// extracted by mini-css-extract-plugin
module.exports = {"welcomeImage":"index_welcomeImage__uVzYB","mapWrapper":"index_mapWrapper__X2pix","footer":"index_footer__7ek2e","primaryButton":"index_primaryButton__ZxdLi"};